import { Layout, ContextBar, Header as BrHeader } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent, ReactNode } from 'react';
import { HeaderLogo } from '../HeaderLogo/HeaderLogo';
import { HeaderTitle } from './HeaderTitle';

type Props = {
  navigation: ReactNode;
};

export const BaseHeader: FunctionComponent<Props> = ({ navigation }) => {
  return (
    <BrHeader className="u-m-none" testId="appHeader" staticHeader logo={<HeaderLogo />}>
      <Layout flush className="u-1/1">
        <Layout.Item default="1/3">
          <ContextBar isContextBar>
            <HeaderTitle />
          </ContextBar>
        </Layout.Item>

        <Layout.Item default="2/3">{navigation}</Layout.Item>
      </Layout>
    </BrHeader>
  );
};
